import { useCallback, useEffect, useState } from 'react';
import { Encumbrance } from 'types';
import { getEncumbrance } from '../api/getEncumbrance';

type UseGetEncumbranceProps = {
  encumbranceId?: string;
  refetchKey?: number;
};

export const useGetEncumbrance = ({
  encumbranceId,
  refetchKey,
}: UseGetEncumbranceProps) => {
  const [encumbrance, setEncumbrance] = useState<Encumbrance | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchEncumbrance = useCallback(
    async (controller: AbortController) => {
      if (!encumbranceId) return;

      try {
        setIsLoading(true);

        const encumbrance = await getEncumbrance({
          encumbranceId,
          signal: controller.signal,
        });

        if (!controller.signal.aborted) {
          setEncumbrance(encumbrance);
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [encumbranceId, refetchKey]
  );

  useEffect(() => {
    const controller = new AbortController();
    fetchEncumbrance(controller);
    return () => controller.abort();
  }, [fetchEncumbrance]);

  return {
    data: {
      encumbrance,
    },
    isLoading,
    isError,
  };
};
